import { getCurrentDate } from '../../../helpers/formatDate'
import { downloadCsvRows } from './downloads/exportRouteUserReportFiles'
import { buildActivityCsvTableRows } from './downloads/activityBreakdownCsvBuilder'

export const exportActivityBreakdownTableCsv = (rows = []) => {
  if (!rows.length) return
  downloadCsvRows(buildActivityCsvTableRows(rows), `Actividades_Desglose_${getCurrentDate()}.csv`)
}
